import React, { useState, useEffect, useContext } from 'react';
import api from '../services/api';
import { AuthContext } from '../context/AuthContext';
import { showToast } from '../components/Toast';
import './Perfil.css';

const Perfil = () => {
  const { usuario: usuarioContext, verificarToken } = useContext(AuthContext);
  const [usuario, setUsuario] = useState({
    nombre: '',
    email: '',
    empresa: '',
    telefono: ''
  });
  const [password, setPassword] = useState({
    actual: '',
    nueva: '',
    confirmar: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    cargarPerfil();
  }, []);

  const cargarPerfil = async () => {
    try {
      const response = await api.get('/usuario/perfil');
      if (response.data.success) {
        setUsuario(response.data.usuario);
      }
    } catch (err) {
      setError('Error al cargar perfil');
    } finally {
      setLoading(false);
    }
  };

  const handleUsuarioChange = (e) => {
    setUsuario({
      ...usuario,
      [e.target.name]: e.target.value
    });
  };

  const handlePasswordChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value
    });
  };

  const guardarPerfil = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSaving(true);

    try {
      const datos = { ...usuario };
      if (password.nueva && password.nueva.length >= 6) {
        if (password.nueva !== password.confirmar) {
          showToast('Las contraseñas no coinciden', 'error');
          setError('Las contraseñas no coinciden');
          setSaving(false);
          return;
        }
        if (password.nueva.length < 6) {
          showToast('La contraseña debe tener al menos 6 caracteres', 'warning');
          setError('La contraseña debe tener al menos 6 caracteres');
          setSaving(false);
          return;
        }
        datos.password = password.nueva;
      }

      await api.put('/usuario/perfil', datos);
      showToast('Perfil actualizado exitosamente', 'success');
      setSuccess('Perfil actualizado exitosamente');
      setPassword({ actual: '', nueva: '', confirmar: '' });
      await verificarToken();
    } catch (err) {
      const errorMsg = err.response?.data?.message || 'Error al actualizar perfil';
      showToast(errorMsg, 'error');
      setError(errorMsg);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="loading">Cargando perfil...</div>;
  }

  return (
    <div className="main-content">
      <div className="container">
        <h1>Mi Perfil</h1>

        {error && <div className="error">{error}</div>}
        {success && <div className="success">{success}</div>}

        <form onSubmit={guardarPerfil} className="perfil-form">
          <div className="perfil-section">
            <h2>Información Personal</h2>
            
            <div className="form-group">
              <label>Nombre Completo *</label>
              <input
                type="text"
                name="nombre"
                value={usuario.nombre}
                onChange={handleUsuarioChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={usuario.email}
                disabled
                className="disabled-input"
              />
              <small>El email no se puede cambiar</small>
            </div>

            <div className="form-group">
              <label>Empresa</label>
              <input
                type="text"
                name="empresa"
                value={usuario.empresa || ''}
                onChange={handleUsuarioChange}
              />
            </div>

            <div className="form-group">
              <label>Teléfono</label>
              <input
                type="tel"
                name="telefono"
                value={usuario.telefono || ''}
                onChange={handleUsuarioChange}
              />
            </div>
          </div>

          <div className="perfil-section">
            <h2>Cambiar Contraseña</h2>
            <p className="section-description">
              Deja en blanco si no deseas cambiar la contraseña
            </p>

            <div className="form-group">
              <label>Nueva Contraseña</label>
              <input
                type="password"
                name="nueva"
                value={password.nueva}
                onChange={handlePasswordChange}
                placeholder="Mínimo 6 caracteres"
              />
            </div>

            <div className="form-group">
              <label>Confirmar Nueva Contraseña</label>
              <input
                type="password"
                name="confirmar"
                value={password.confirmar}
                onChange={handlePasswordChange}
                placeholder="Repite la nueva contraseña"
              />
            </div>
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={saving}
            >
              {saving ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Perfil;

